import { OndemandRide, RidangoReduxAction } from '@ridango/core';

import { RideBookingsActions } from './ride-bookings.actions';

export const RIDE_BOOKINGS_STATE_KEY = 'rideBookings';

export interface RideBookingsState {
    bookings: OndemandRide[];
    loading: boolean;
    error: any;
}

export const RIDE_BOOKINGS_INITIAL_STATE: RideBookingsState = {
    bookings: [],
    loading: false,
    error: {},
};

export function rideBookingsReducer(
    state: RideBookingsState = RIDE_BOOKINGS_INITIAL_STATE,
    action: RidangoReduxAction
): RideBookingsState {
    switch (action.type) {
        case RideBookingsActions.FETCH_RIDE_BOOKINGS:
            return {
                ...state,
                loading: true,
            };
        case RideBookingsActions.FETCH_RIDE_BOOKINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                bookings: action.payload,
            };
        case RideBookingsActions.FETCH_RIDE_BOOKINGS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
    }

    return state;
}

export interface RideBookingsPartialStoreState {
    [RIDE_BOOKINGS_STATE_KEY]: RideBookingsState;
}
